import { Reducer } from "redux";
import { Action, ActionType } from "../../../actions";
import { EditorData } from "../../../state/BookingCreateManager/SSR/EditorData";

const updateEditorData: Reducer<EditorData> = (state: EditorData = new EditorData(), action: Action<ActionType, EditorData>) => {
  switch (action.type) {
    case ActionType.BOOKING_CREATE_MANAGER_SSR_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.BOOKING_CREATE_MANAGER_SSR_EDITOR_DATA_FETCHED:
      return { ...state, bcmSsrEditorData: action.data };
    case ActionType.BOOKING_CREATE_MANAGER_SSR_EDITOR_DATA_COPIED:
      return { ...state, bcmSsrEditorData: { ...action.data} };
    case ActionType.BOOKING_CREATE_MANAGER_SSR_EDITOR_DATA_UPDATED:
      return { ...state, bcmSsrEditorData: { ...state.bcmSsrEditorData, ...action.data } };
    case ActionType.BOOKING_CREATE_MANAGER_SSR_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.BOOKING_CREATE_MANAGER_SSR_EDITOR_DATA_VALIDATED:
      return { ...state, validation: {...action.data }};
    case ActionType.BOOKING_CREATE_MANAGER_SSR_EDITOR_SET_BOUND_ITEM:
      return {...state, bcmSsrEditorData: {...state.bcmSsrEditorData, ...action.data}}
    default:
      return state;
  }
};

export default updateEditorData;
